var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yxtf-link',_vm._g({staticClass:"lc-am-link-container",attrs:{"type":_vm.type,"underline":_vm.underline,"href":_vm.linkHref,"target":_vm.linkTarget ? '_blank' : '_self',"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }